import axios from 'axios';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { store, logout } from '../store';

const BASE_URL = process.env.EXPO_PUBLIC_API_URL || 'http://localhost:3000/api';

export const api = axios.create({ baseURL: BASE_URL, timeout: 15_000 });

api.interceptors.request.use(async (config) => {
  const token = await AsyncStorage.getItem('@cp_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const status = err.response?.status;
    const banned = status === 403 && err.response?.data?.code === 'BANNED';
    if (status === 401 || banned) {
      // Sign out — but only act ONCE. During bootstrap several requests fire in parallel,
      // so without this guard an expired token triggers a logout storm (each in-flight 401
      // re-dispatches logout). logout() already clears every auth key + resets the jobs slice.
      if (store.getState().auth.token) {
        store.dispatch(logout());
      }
    }
    return Promise.reject(err);
  },
);
